module.exports = __webpack_public_path__ + "media/images/thumb/map-marker-pink-2c1b105760daf7e3dacaa69601b75417.png";